import React from 'react';

import { buildInfo } from '@/shared/buildInfo';

const VersionBadge = ({ className }) => {
    const version = buildInfo.version;
    return (
        <div title={`${buildInfo.gitSha} · ${buildInfo.buildTime}`} className={`px-2.5 py-0.5 rounded-md bg-white/50 backdrop-blur-sm border border-gray-200 text-xs text-gray-500 font-mono ${className}`}>
            v{version}
        </div>
    );
};

export default VersionBadge;
